"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SpamFolderOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M4,27H28a2,2,0,0,0,2-2V9a2,2,0,0,0-2-2H15.46l-1.7-2.55A1,1,0,0,0,12.93,4H4A2,2,0,0,0,2,6V25A2,2,0,0,0,4,27ZM4,6h8.39L13.8,8.11l.59.89H28V25H4Z"/><path d="M19.59,12.2a6,6,0,0,0-8.39,8.39,5.78,5.78,0,0,0,1.21,1.21,6,6,0,0,0,8.39-8.39A5.78,5.78,0,0,0,19.59,12.2ZM11.71,17a4.28,4.28,0,0,1,6.65-3.57l-5.93,5.93A4.27,4.27,0,0,1,11.71,17ZM16,21.29a4.27,4.27,0,0,1-2.36-.72l5.93-5.93A4.28,4.28,0,0,1,16,21.29Z"/>';
var SpamFolderOutlineSVG = function SpamFolderOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.SpamFolderOutlineSVG = SpamFolderOutlineSVG;
SpamFolderOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(SpamFolderOutlineSVG);
exports.default = _default;